"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _Label = _interopRequireDefault(require("../../text/Label"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledInput = (0, _styledComponents["default"])(_pclnDesignSystem.Input).withConfig({
  componentId: "rbrcd0-0"
})(["color:", ";"], (0, _pclnDesignSystem.getPaletteColor)('text.dark'));

function Input(_ref) {
  var className = _ref.className,
      id = _ref.id,
      disabled = _ref.disabled,
      type = _ref.type,
      color = _ref.color,
      label = _ref.label,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["className", "id", "disabled", "type", "color", "label", "value", "placeholder", "onChange"]);

  return _react["default"].createElement(_Label["default"], {
    className: className
  }, label, _react["default"].createElement(StyledInput, _extends({
    id: id,
    disabled: disabled,
    type: type,
    color: color,
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    mt: 2
  }, props)));
}

Input.displayName = 'Input';
Input.propTypes = {
  className: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
Input.defaultProps = {
  className: '',
  color: 'primary'
};
var _default = Input;
exports["default"] = _default;